export const smallBreakpoint = 576
export const mobileBreakpoint = 768
export const largeBreakpoint = 992
export const extraLargeBreakpoint = 1200

export const listBreakpoint = 1100

// Used with topbar and menu to determine if the screen is small enough to hide the menu and use the mobile fullscreen menu
export const navigationBreakpoint = 767

export const pageMaxwidthMedium = 1140
export const pageMaxwidthLarge = 1340
export const pageMaxwidthExtraLarge = 1540

export const linkColor = '#1657e2' // TODO: move to snorre
